import Loader from 'components/Loader'

const Image = ({
  src,
  alt,
  isImage,
  fallbackImageSrc,
  fallbackImageAlt,
  isLoading = false,
}) => {
  if (isLoading) return <Loader container={false} small={true} />

  if (isImage) {
    return <img src={src} alt={alt} />
  } else {
    return <img src={fallbackImageSrc} alt={fallbackImageAlt} />
  }
}
export default Image
